export const SHOW_SITE_MESSAGE = 'SHOW_MESSAGE';
export const RESET_SITE_MESSAGE = 'RESET_SITE_MESSAGE';
export const CLOSE_SITE_MESSAGE = 'CLOSE_SITE_MESSAGE';

export function showSiteMessage(message, route) {
    return {
        type: SHOW_SITE_MESSAGE,
        payload: {
            message: message,
            route: route
        }
    };
}

export function resetSiteMessage() {
    return {
        type: RESET_SITE_MESSAGE,
        payload: {}
    };
}

export function closeSiteMessage() {
    return {
        type: CLOSE_SITE_MESSAGE
    };
}
